export enum CheckboxStateEnum {
	CHECKBOX_NO = 0,
	CHECKBOX_YES = 1,
	CHECKBOX_UNTOUCHED = undefined
}
